import React, { useContext, useMemo, useRef } from "react";
import classNames from "classnames";
import { Label, View } from "../_core/components";
import { pxTransform } from "../_util/px-transform";
import { Icon } from "../icon";
import { isChildOfType } from "../_util/is-child-of-type";
import { Checkbox } from "../checkbox";
import { Radio } from "../radio";
import { FormContext } from "./FormContext";
import { useConfig } from "../_util/use-config";
export function FormItem(_a) {
    var _b;
    var label = _a.label, 
    // for: htmlFor,
    labelWidth = _a.labelWidth, arrow = _a.arrow, error = _a.error, required = _a.required, message = _a.message, placeholder = _a.placeholder, extra = _a.extra, vertical = _a.vertical, children = _a.children, className = _a.className, style = _a.style, onClick = _a.onClick;
    var classPrefix = useConfig().classPrefix;
    var formLabelWidth = useContext(FormContext).labelWidth;
    var itemLabelWidth = useMemo(function () {
        var width = labelWidth || formLabelWidth || "6em";
        return typeof width === "number" ? pxTransform(width, 750) : width;
    }, [labelWidth, formLabelWidth]);
    var ref = useRef(null);
    // children 包含 Check 时整行可点击
    if (isChildOfType(children, Checkbox) || isChildOfType(children, Radio)) {
        // eslint-disable-next-line no-param-reassign
        children = React.cloneElement(children, { ref: ref });
        // eslint-disable-next-line no-param-reassign
        onClick = function (event) {
            ref.current && ref.current.trigger(event);
        };
    }
    if (error && typeof error !== "boolean") {
        // eslint-disable-next-line no-param-reassign
        message = error;
    }
    return (React.createElement(View, { className: classNames(classPrefix + "-form-item", classPrefix + "-item", classPrefix + "-hairline--bottom", "size-auto", className, (_b = {
                "is-clickable": arrow || onClick,
                "is-required": required
            },
            _b[classPrefix + "-form-item--vertical"] = vertical,
            _b[classPrefix + "-form-item--invalid"] = error,
            _b)), style: style, onClick: onClick },
        typeof label !== "undefined" && (React.createElement(View, { className: classPrefix + "-item__body", style: {
                maxWidth: itemLabelWidth,
                minWidth: itemLabelWidth,
            } },
            React.createElement(Label, { className: classPrefix + "-item__title " + classPrefix + "-form-item__label" }, label))),
        React.createElement(View, { className: classPrefix + "-item__value " + classPrefix + "-form-item__value" },
            React.createElement(View, { className: classPrefix + "-form-item__controls" },
                children || (React.createElement(View, { className: classPrefix + "-form-item__placeholder" }, placeholder)),
                React.createElement(View, { className: classPrefix + "-form-item__extra" }, extra)),
            message && (React.createElement(View, { className: error
                    ? classPrefix + "-form-item__invalid-text"
                    : classPrefix + "-form-item__helper-text" }, message))),
        arrow && (React.createElement(Icon, { className: classPrefix + "-item__detail-icon", name: "chevronright", color: "#bbbbbb" }))));
}
//# sourceMappingURL=FormItem.js.map